import { INSTANCE_URL, FILES_URL } from '../../Common/constant';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import { fetchAndFilterByBookMark } from '../../../actions';
import { FILTER_LIST_OPEN } from '../../attendee/actions';

export const FETCH_SOCIAL_FEED = 'FETCH_SOCIAL_FEED';
export const FETCH_SOCIAL_FEED_COMMENT = 'FETCH_SOCIAL_FEED_COMMENT';
export const SET_SOCIAL_FEED_COMMENT = 'SET_SOCIAL_FEED_COMMENT';
export const OPEN_SOCIAL_FEED_IMAGE = 'OPEN_SOCIAL_FEED_IMAGE';
export const OPEN_SOCIAL_POST_ADD = 'OPEN_SOCIAL_POST_ADD';
export const FETCH_SOCIAL_FEED_LIKE = 'FETCH_SOCIAL_FEED_LIKE';

export const fetchSocialFeed = (
  session,
  pageCount = 0,
  dataArr = [],
  callback
) => {
  let perPage = 20;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;
  let filter = encodeURI(`(eventid=${session.eventid})AND(isvisible=1)`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeed?include_count=true&related=appuser_by_postedbyid,socialfeedlikes_by_socialfeedid,socialfeedcomments_by_socialfeedid,socialfeedpollresult_by_socialfeedidfk&filter=(${filter})&eventid=${session.eventid}&order=createdon%20DESC&${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {
            data: dataArr.concat(data.resource),
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: data.resource,
          total_count: data.meta.count,
          next: data.meta.next
        });
      },
      error => {}
    );
  };
};

export const getFeeds = (session, page, callback) => {
  let limit = page == 0 ? 20 : page;
  let offSetQuery = `&limit=${limit}&offset=0`;
  let filter = encodeURI(`(eventid=${session.eventid})AND(isvisible=1)`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeed?include_count=true&related=appuser_by_postedbyid,socialfeedlikes_by_socialfeedid,socialfeedcomments_by_socialfeedid,socialfeedpollresult_by_socialfeedidfk&filter=(${filter})&eventid=${session.eventid}&order=createdon%20DESC${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {
            data: data.resource,
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: data.resource,
          total_count: data.meta.count,
          next: data.meta.next
        });
      },
      error => {}
    );
  };
};

export const postLike = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedlikes`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const postDislike = (session, socialfeedid, callback) => {
  let filter = encodeURI(
    `(socialfeedid=${socialfeedid})AND(likedbyid=${session.userid})AND(eventid=${session.eventid})`
  );
  let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedlikes?filter=${filter}`;
  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteFeed = (session, socialfeedid, callback) => {
  let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeed/${socialfeedid}`;
  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const reportFeed = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedhide`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearFeedComment = () => {
  return dispatch => {
    dispatch({ type: FETCH_SOCIAL_FEED_COMMENT, payload: {} });
  };
};

export const setFeedComment = (showModal = false, socialfeedid = '') => {
  return dispatch => {
    dispatch({
      type: SET_SOCIAL_FEED_COMMENT,
      payload: {
        showModal: showModal,
        socialfeedid: socialfeedid
      }
    });
  };
};

export const fetchComments = (session, socialfeedid, callback) => {
  let filter = encodeURI(
    `(socialfeedid=${socialfeedid})AND(eventid=${session.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedcomments?related=appuser_by_commentbyid&filter=(${filter})&order=createdon%20ASC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_SOCIAL_FEED_COMMENT, payload: data });
        callback({ success: 1, resource: data.resource });
      },
      error => {}
    );
  };
};

export const sendChat = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedcomments`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const openSocialImage = (
  showModal = false,
  item = [],
  currentindex = ''
) => {
  return dispatch => {
    dispatch({
      type: OPEN_SOCIAL_FEED_IMAGE,
      payload: {
        showModal: showModal,
        photo: item,
        currentindex: currentindex
      }
    });
  };
};

export const addPostModal = (showModal = false) => {
  return dispatch => {
    dispatch({
      type: OPEN_SOCIAL_POST_ADD,
      payload: {
        showModal: showModal
      }
    });
  };
};

export const addSocialFeed = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeed`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const uploadMedia = (session, uploadFiles, callback) => {
  let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
  let filename = `eventify/${session.eventid}/social/${uploadFiles.name}`;

  let mediaJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: filecontent
      }
    ]
  };
  return dispatch => {
    uploadEncodedFile(
      `${FILES_URL}?check_exist=false`,
      session,
      mediaJson,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const addSocialFeedPoll = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedpollresult`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteComment = (session, socialfeedcommentid, callback) => {
  let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedcomments/${socialfeedcommentid}`;

  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchLikeList = (session, socialfeedid, callback) => {
  let filter = encodeURI(
    `(socialfeedid=${socialfeedid})AND(eventid=${session.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeedlikes?related=appuser_by_likedbyid&filter=(${filter})&order=createdon%20ASC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_SOCIAL_FEED_LIKE, payload: data });
        callback({ success: 1, resource: data.resource });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const clearFeedLike = () => {
  return dispatch => {
    dispatch({ type: FETCH_SOCIAL_FEED_LIKE, payload: {} });
  };
};
